import React, { useState, useEffect } from "react";
import styled from "styled-components";
const Input = styled.input`
  margin-left: 12px;
  margin-right: 12px;
`;

export default function SizeCalculatorPrinter(props) {
  const inputField = props.lastUserInputField;
  const input = parseFloat(props.lastUserInput);
  const ratio = parseFloat(props.ratio);

  const initialHoehe =
    inputField === "breite" ? parseFloat((input / ratio).toFixed(1)) : input;
  const initialBreite =
    inputField === "hoehe" ? parseFloat((input * ratio).toFixed(1)) : input;

  const [hoehe, setHoehe] = useState(initialHoehe);
  const [breite, setBreite] = useState(initialBreite);

  useEffect(() => {
    let hoeheBerechnet = parseFloat((input / ratio).toFixed(1));
    let breiteBerechnet = parseFloat((input * ratio).toFixed(1));

    let newHoehe = inputField === "breite" ? hoeheBerechnet : input;
    let newBreite = inputField === "hoehe" ? breiteBerechnet : input;

    // Enforce maximum size constraints
    if (newBreite > 120) {
      newHoehe = Math.min(newHoehe, 1000);
    }
    if (newHoehe > 120) {
      newBreite = Math.min(newBreite, 1000);
    }

    // Ensure neither value exceeds 1000
    newHoehe = Math.min(newHoehe, 1000);
    newBreite = Math.min(newBreite, 1000);

    setHoehe(newHoehe);
    setBreite(newBreite);
  }, [input, inputField, ratio, breite, hoehe]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    props.setInput(e); // Assuming props.setInput updates lastUserInput and lastUserInputField

    if (name === "breite") {
      const newBreite = parseFloat(value);
      const newHoehe = parseFloat((newBreite / ratio).toFixed(1));
      setBreite(newBreite);
      setHoehe(Math.min(newHoehe, 1000));
    } else if (name === "hoehe") {
      const newHoehe = parseFloat(value);
      const newBreite = parseFloat((newHoehe * ratio).toFixed(1));
      setHoehe(newHoehe);
      setBreite(Math.min(newBreite, 1000));
    }
  };

  if ((hoehe > 120 && breite > 120) || breite > 1000 || hoehe > 1000) {
    setHoehe(5);
    setBreite((5 * ratio).toFixed(1));
  }

  return (
    <div className="auswahl">
      <form className="mk-form">
        <label className="mk-label" htmlFor="breite">
          Breite
          <br /> (cm)
        </label>
        <Input
          className="mk-input"
          type="number"
          id="breite"
          name="breite"
          onChange={handleInputChange}
          value={breite}
          pattern="[0-9]+([\.,][0-9]+)?"
          step="0.1"
          min="1"
          max="400"
        />

        <label className="mk-label" htmlFor="breite" id="x">
          x
        </label>
        <Input
          className="mk-input"
          type="number"
          id="hoehe"
          name="hoehe"
          onChange={handleInputChange}
          value={hoehe}
          pattern="[0-9]+([\.,][0-9]+)?"
          step="0.1"
          min="1"
          max="400"
        />

        <label className="mk-label" htmlFor="hoehe">
          Höhe
          <br /> (cm)
        </label>
      </form>
    </div>
  );
}
